import React from 'react'
import { MapPin, Phone, Mail, Facebook, Instagram, Youtube, Linkedin, } from 'lucide-react';
import ImagesPallet from '../../../utils/ImagesPallet';
import ColorPallet from '../../../utils/ColorPallet';

function FooterSection() {
  return (
    <footer className=" text-white py-12" style={{ backgroundColor: ColorPallet.secondLightBrown }}>
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img src={ImagesPallet.HeroLogo} alt="Papakilo Barbershop" className="h-56" width={250}/>
            <p className="text-sm">
              Papakilo Hairstudio adalah perusahaan yang bergerak dibidang jasa (Barbershop & Salon), Papakilo didirikan pada tahun 2023.
            </p>
            <div className="flex space-x-4">
              <Facebook className="w-5 h-5 hover:text-yellow-500 cursor-pointer" />
              <Instagram className="w-5 h-5 hover:text-yellow-500 cursor-pointer" />
              <Youtube className="w-5 h-5 hover:text-yellow-500 cursor-pointer" />
              <Linkedin className="w-5 h-5 hover:text-yellow-500 cursor-pointer" />
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-black font-bold mb-4">COMPANY</h3>
            <ul className="space-y-2">
              <li><a href="/story" className="hover:text-black">Story</a></li>
              <li><a href="/mission" className="hover:text-black">Mission</a></li>
              <li><a href="/lokasi" className="hover:text-black">Lokasi</a></li>
              <li><a href="/csr" className="hover:text-black">CSR</a></li>
              <li><a href="/captain-academy" className="hover:text-black">Papakilo Academy</a></li>
            </ul>
          </div>

          {/* Other Links */}
          <div>
            <h3 className="text-black font-bold mb-4">OTHER</h3>
            <ul className="space-y-2">
              <li><a href="/trend-rambut" className="hover:text-black">Trend Rambut</a></li>
              <li><a href="/gallery" className="hover:text-black">Gallery</a></li>
              <li><a href="/karir" className="hover:text-black">Karir</a></li>
              <li><a href="/kontak" className="hover:text-black">Kontak</a></li>
              <li><a href="/privacy-policy" className="hover:text-black">Privacy Policy</a></li>
              <li><a href="/terms" className="hover:text-black">Term of Service</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-black font-bold mb-4">SUPPORT</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-2">
                <MapPin className="h-20 w-20 -mt-7" />
                <span>The City Resort Residence Rukan Malibu Bl. H, Jl. Boulevard Raya No. 2-3, Cengkareng Timur, Kecamatan Cengkareng, Kota Jakarta Barat, Daerah Khusus Ibukota Jakarta 11730</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-5 w-5" />
                <span>0852 8241 1391</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-5 w-5" />
                <span>papakilobarbershop@gmail.com</span>
              </div>
              <div className="flex items-center space-x-4">
                <a href="#" className="hover:text-yellow-500">Android</a>
                <a href="#" className="hover:text-yellow-500">Mac iOS</a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white mt-8 pt-8 text-center text-white text-sm">
          <p>Copyright © 2025 All rights reserved | Papakilo Hairstudio | A member of Sukses Corp International</p>
        </div>
      </div>
    </footer>
  )
}

export default FooterSection